import React from 'react';

export const CalendarIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3661 1.971H13.0141C13.7269 1.971 14.3101 2.5542 14.3101 3.267V13.635C14.3101 14.3478 13.7269 14.931 13.0141 14.931H2.6461C1.9333 14.931 1.3501 14.3478 1.3501 13.635V3.267C1.3501 2.5542 1.9333 1.971 2.6461 1.971H3.2941V0.675003H4.5901V1.971H11.0701V0.675003H12.3661V1.971ZM2.6461 13.635H13.0141V6.507H2.6461V13.635ZM13.0141 5.211H2.6461V3.267H13.0141V5.211ZM16.2959 4.32387C16.2537 4.09133 16.0502 3.915 15.8055 3.915L15.7159 3.92303C15.4834 3.96524 15.307 4.16876 15.307 4.41346V15.8781H3.84241L3.75281 15.8861C3.52028 15.9283 3.34394 16.1318 3.34394 16.3765C3.34394 16.6518 3.56711 16.875 3.84241 16.875H15.8055L15.8951 16.867C16.1276 16.8248 16.3039 16.6212 16.3039 16.3765V4.41346L16.2959 4.32387Z"
      fill="#687587"
    />
  </svg>
);
